import { useDocStore } from '../../stores/DocStore'

export const useCollaborationCount = () => {
  const docStore = useDocStore()
  const commentsCount = docStore.comments.filter(
    (comment) => comment.read_status === false && !comment.resolved_at,
  ).length
  const toDosCount = docStore.todos.filter((todo) => todo.read_status === false && !todo.completed_at).length

  return commentsCount + toDosCount
}
